import { Component, Input } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
    selector: 'form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss']
})

export class FormErrorComponent {

    public active: boolean;
    @Input() public errorInputs: Array<string>;
    @Input() public key: string;
    @Input() public label: string;
    @Input() public iclass: string;
    @Input() public divclass: string;
    @Input() public asterisk: boolean;
    @Input() public timeout: number;
    public timeoutObject: any;

    constructor(public sharedService: SharedService) {
        this.active = false;
        this.asterisk = true;
        this.timeout = null;
        this.divclass = '';
    }

    ngOnChanges() {
        clearTimeout(this.timeoutObject);
        this.active = this.errorInputs ? this.errorInputs.includes(this.key) : false;
        if (this.active) {
            this.sharedService.sendMessage('FORM_ERROR_SHOW', this.key);
            if (this.timeout !== null) {
                this.timeoutObject = setTimeout(this.hide, this.timeout * 1000);
            }
        }
    }

    hide() {
        this.active = false;
        this.sharedService.sendMessage('FORM_ERROR_HIDE', this.key);
        clearTimeout(this.timeoutObject);
    }

    getLabel() {
        return this.asterisk ? "* " + this.label : this.label;
    }

}
